
import { defineComponent } from "vue";

export default defineComponent({
  name: "PlusMinusScorer",
  props: {
    score: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    let positiveColour = 0;
    let positiveGrey = 0;
    let negativeColour = 0;
    let negativeGrey = 0;

    function checkScore(score: number) {
      if (score > 0 && score <= 3) {
        positiveColour = score;
        positiveGrey = 3 - score;
        negativeGrey = 3;
      } else if (score < 0 && score >= -3) {
        negativeColour = Math.abs(score);
        negativeGrey = 3 - Math.abs(score);
        positiveGrey = 3;
      } else {
        positiveGrey = 3;
        negativeGrey = 3;
      }
    }
    checkScore(props.score);

    return { positiveColour, positiveGrey, negativeColour, negativeGrey };
  },
});
